export type RecordDiscussionPlacement = 'left' | 'right' | 'off';

const PLACEMENT_KEY = 'jarvis.patientTracking.recordDiscussion.placement';
const AUTO_HIDE_KEY = 'jarvis.patientTracking.recordDiscussion.autoHide';

export const RECORD_DISCUSSION_PLACEMENT_CHANGED_EVENT =
  'jarvis-record-discussion-placement-changed';

export const RECORD_DISCUSSION_AUTO_HIDE_CHANGED_EVENT =
  'jarvis-record-discussion-auto-hide-changed';

export function readRecordDiscussionPlacement(): RecordDiscussionPlacement {
  try {
    const stored = localStorage.getItem(PLACEMENT_KEY);
    if (stored === 'left' || stored === 'right' || stored === 'off') return stored;
  } catch {
    /* storage unavailable */
  }
  return 'right';
}

export function writeRecordDiscussionPlacement(placement: RecordDiscussionPlacement): void {
  try {
    localStorage.setItem(PLACEMENT_KEY, placement);
    if (typeof window !== 'undefined') {
      window.dispatchEvent(new CustomEvent(RECORD_DISCUSSION_PLACEMENT_CHANGED_EVENT));
    }
  } catch {
    /* ignore */
  }
}

export function readAutoHideRecordDiscussionPanel(): boolean {
  try {
    return localStorage.getItem(AUTO_HIDE_KEY) === '1';
  } catch {
    return false;
  }
}

export function writeAutoHideRecordDiscussionPanel(autoHide: boolean): void {
  try {
    localStorage.setItem(AUTO_HIDE_KEY, autoHide ? '1' : '0');
    if (typeof window !== 'undefined') {
      window.dispatchEvent(new CustomEvent(RECORD_DISCUSSION_AUTO_HIDE_CHANGED_EVENT));
    }
  } catch {
    /* ignore */
  }
}
